import BaseClosedCaptionsProvider from "./BaseProvider";

class DesktopClosedCaptionsProvider extends BaseClosedCaptionsProvider {}

export default DesktopClosedCaptionsProvider;
